module.exports = __webpack_public_path__ + "img/women_clothing_hover.79ea4ec0.png";